// extracted by mini-css-extract-plugin
module.exports = {"tfbInput":"TFBInput_tfbInput__1UQEx","inputLabel":"TFBInput_inputLabel__3G6aD","inputGroup":"TFBInput_inputGroup__1Jjbv"};